import { Injectable } from '@angular/core';
import { environment } from '../../app/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ScriptLoaderService {
  loadAuthorizeNetScript(): void {
    const scriptId = 'accept-js';

    if (document.getElementById(scriptId)) {
      return; // already loaded
    }

    const script = document.createElement('script');
    script.id = scriptId;
    script.src = environment.app.acceptJsUrl;
    script.type = 'text/javascript';
    script.charset = 'utf-8';
    document.body.appendChild(script);

    const script2: any = document.createElement('script');
    script2.src = 'https://cdn.agenqglobal.com/agenq-widget.iife.js';
    script2.onload = () => {
    (window as any).renderAGENQWidget('agent-container', {});
    };
    script2.type = 'text/javascript';
    script2.charset = 'utf-8';
    document.body.appendChild(script2);
  }

  // loadAuthorizeNetScript(): void {
  //   const scriptId = 'accept-js';

  //   if (document.getElementById(scriptId)) {
  //     return; // already loaded
  //   }

  //   // Save original console
  //   const originalLog = console.log;

  //   // Temporarily silence logs
  //   console.log = () => { };

  //   // -------- Load Authorize.Net Script --------
  //   const script = document.createElement('script');
  //   script.id = scriptId;
  //   script.src = environment.app.acceptJsUrl;
  //   script.type = 'text/javascript';
  //   script.charset = 'utf-8';

  //   script.onload = () => {
  //     console.log = originalLog; // restore after load
  //   };

  //   script.onerror = () => {
  //     console.log = originalLog; // restore if error
  //   };

  //   document.body.appendChild(script);

  //   // -------- Load Agenq Widget --------
  //   const script2: any = document.createElement('script');
  //   script2.src = 'https://dummy.com/agenq-widget.iife.js';
  //   script2.type = 'text/javascript';
  //   script2.charset = 'utf-8';

  //   script2.onload = () => {
  //     try {
  //       (window as any).renderAGENQWidget('agent-container', {});
  //     } finally {
  //       console.log = originalLog; // ensure restore
  //     }
  //   };

  //   script2.onerror = () => {
  //     console.log = originalLog;
  //   };

  //   document.body.appendChild(script2);
  // }

}
